import { render, staticRenderFns } from "./my_payslips.vue?vue&type=template&id=b0fa2ad4&scoped=true&"
import script from "./my_payslips.vue?vue&type=script&lang=js&"
export * from "./my_payslips.vue?vue&type=script&lang=js&"
import style0 from "./my_payslips.vue?vue&type=style&index=0&id=b0fa2ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fa2ad4",
  null
  
)

export default component.exports